var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBGremover = function SvgBGremover(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 18"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#E5E5E5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.526 8.965 6.34 11.163c-1.06 1.066-1.59 1.598-1.59 2.262s.53 1.196 1.59 2.262l.248.25c.227.228.34.342.484.401.144.06.303.06.623.06h1.663c.32 0 .48 0 .623-.06s.257-.174.484-.401l2.498-2.512m-4.437-4.46 1.498-1.506c1.031-1.036 1.547-1.555 2.185-1.56h.03c.638.005 1.153.524 2.184 1.56C15.47 8.512 15.993 9.04 16 9.693v.03c-.006.655-.53 1.181-1.577 2.234l-1.46 1.468m-4.437-4.46 4.437 4.46M6.25 6.648 5.125 4.023m0 0L4.138 1.72a.44.44 0 0 0-.368-.317c-.033-.005-.07-.005-.145-.005s-.112 0-.145.005a.44.44 0 0 0-.31.194c-.017.027-.03.06-.058.123l-.987 2.303m3 0h-3m0 0L1 6.648"
  }))));
};
export default SvgBGremover;